/* eslint-disable func-names */
/* eslint-disable default-param-last */
import { SET_APPOINTMENT } from '../Actions';

export default function (state = {}, action) {
  switch (action.type) {
    case SET_APPOINTMENT:
      return action.payload;
    default:
      return state;
  }
}
